var render = function render(){var _vm=this,_c=_vm._self._c;return _c('embed',{attrs:{"src":"files/aviz/Washington_Aviz.pdf","type":"application/pdf","width":"100%","height":"100%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }